import HorizontalDividers from 'components/CustomDividers/HorizontalDividers';
import VerticalDividers from 'components/CustomDividers/VerticalDividers';
import { DialogContentStyled, Label, LeftContentWrapper, RightContentWrapper } from 'components/Dialog/DialogContent';
import { LeftContent } from 'components/Dialog/DialogLeftContent';
import { Bottom, BottomActions, ConnectButton, RightForm } from 'components/Dialog/DialogRightContent';
import { ErrorMessage, Input, InputGrid } from 'components/Form';
import WarningIcon from '@mui/icons-material/Warning';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { getZaloraAuthorizeUrl } from 'api/marketPlaces';
import { useAppStore } from 'stores/appStore';
import { showAlert } from 'components/Alert';
import { DialogProps } from 'interfaces/Props';
import { channels } from 'shared/constants';
import config from 'config';

interface FormValues {
  appId: string;
  appSecret: string;
}
const ZaloraContent: React.FunctionComponent<DialogProps> = ({ handleClosePrimary, getListChannel }) => {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm<FormValues>();
  const { setShowConnectedPopup, disablePrevButton } = useAppStore();

  const onSubmit: SubmitHandler<FormValues> = async (data) => {
    try {
      let payload = {
        appId: data.appId,
        appSecret: data.appSecret
      };
      const res: any = await getZaloraAuthorizeUrl(payload);
      if (res && res?.data && res?.data?.status == 'ok') {
        if (!disablePrevButton) {
          setShowConnectedPopup(true);
          getListChannel();
          handleClosePrimary();
        } else {
          location.replace(config.baseUrl);
        }
      } else {
        showAlert('error', `${res?.data?.message}`, 5000);
      }
    } catch (err) {
      const error = err as Error;
      showAlert('error', `${error}`, 5000);
    }
  };

  return (
    <DialogContentStyled>
      <LeftContentWrapper>
        <LeftContent channelId={channels.ZALORA} />
      </LeftContentWrapper>
      <VerticalDividers />
      <RightContentWrapper>
        <RightForm id="zalora_form" onSubmit={handleSubmit(onSubmit)}>
          <InputGrid
            label={<Label className="requiredField">App ID</Label>}
            input={
              <Input
                isError={errors.appId?.message ? true : false}
                type={'text'}
                placeholder={'App ID'}
                {...register('appId', {
                  required: { value: true, message: 'APP ID harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.appId && (
                <ErrorMessage icon={<WarningIcon fontSize="small" color="error" />} message={errors.appId.message} />
              )
            }
          />
           <InputGrid
            label={<Label className="requiredField">App Secret</Label>}
            input={
              <Input
                isError={errors.appSecret?.message ? true : false}
                type={'text'}
                placeholder={'App Secret'}
                {...register('appSecret', {
                  required: { value: true, message: 'APP Secret harus di isi' }
                })}
              />
            }
            errorMessage={
              errors?.appSecret && (
                <ErrorMessage icon={<WarningIcon fontSize="small" color="error" />} message={errors.appSecret.message} />
              )
            }
          />
        </RightForm>
        <Bottom>
          <HorizontalDividers />
          <BottomActions>
            <ConnectButton form="zalora_form">Sambungkan</ConnectButton>
          </BottomActions>
        </Bottom>
      </RightContentWrapper>
    </DialogContentStyled>
  );
};

export default ZaloraContent;
